module.exports = __webpack_public_path__ + "assets/img/tongdao@2x.c1fd41ea.png";